<script setup>

import {computed, ref, onMounted} from "vue";
import axios from "axios";
import {settingsBreadcrumbsForKey} from "../settings/breadcrumbs";

const loading = ref(true);
const breadcrumbs = computed(() => settingsBreadcrumbsForKey('navigation:backOffice.sidebar.modules.index'));

const modules = ref([
    {
        name: 'Web Pages',
        category: 'Website',
        enabled: false
    },
    {
        name: 'User Area Pages',
        category: 'Website',
        enabled: false
    },
    {
        name: 'Landing Pages',
        category: 'Website',
        enabled: false
    },
    {
        name: 'Coaching',
        category: 'Product',
        enabled: false
    },
    {
        name: 'Content',
        category: 'Product',
        enabled: false
    },
    {
        name: 'Community',
        category: 'Product',
        enabled: false
    },
    {
        name: 'Newsletters',
        category: 'Email',
        enabled: false
    },
    {
        name: 'Automations',
        category: 'Email',
        enabled: false
    },
    {
        name: 'LeadHunter',
        category: 'Email',
        enabled: false
    },
    {
        name: 'Contacts',
        category: 'Toolbox',
        enabled: false
    },
    {
        name: 'Quotes & Agreements',
        category: 'Toolbox',
        enabled: false
    },
    {
        name: 'Time Tracking',
        category: 'Toolbox',
        enabled: false
    },
    {
        name: 'Payments',
        category: 'Toolbox',
        enabled: false
    },
    {
        name: 'Forms',
        category: 'Toolbox',
        enabled: false
    },
]);

const currentModules = ref([]);

const moduleLabels = {
    "Web Pages": "Web pages",
    "User Area Pages": "User Area pages",
    "Landing Pages": "Landing pages",
}

onMounted(() => {
    fetchCurrentModules();
});

const fetchCurrentModules = async () => {
    const response = await fetch(route('modules.current'));
    const data = await response.json();
    currentModules.value = data;

    mapModules();

    loading.value = false;
};

const storeOrUpdate = async () => {
    try {
        const enabledModuleNames = modules.value
            .filter(module => module.enabled)
            .map(module => module.name);

        const response = await axios.post(route('modules.updateCurrentModules'), {
            modules: enabledModuleNames
        });

        window.location.reload();
    } catch (error) {
        console.error('Failed to update modules');
    }
};

const mapModules = () => {
    modules.value.forEach(module => {
        if (Array.isArray(currentModules.value)) {
            module.enabled = currentModules.value.includes(module.name);
        } else if (typeof currentModules.value === 'object') {
            const moduleNames = Object.values(currentModules.value);
            module.enabled = moduleNames.includes(module.name);
        } else {
            module.enabled = false;
        }
    });
};

</script>

<template>
    <div class="w-full">

        <frosted-bar :breadcrumbs="breadcrumbs">
            <div class="flex items-center justify-between space-x-4 f">
                <h1>Modules</h1>

                <div class="flex items-center space-x-4">
                    <button-success
                        @click="storeOrUpdate()"
                    >
                        Save
                    </button-success>
                </div>
            </div>
        </frosted-bar>


        <div
            class="grid grid-cols-1 gap-4 mt-8 md:grid-cols-2 lg:grid-cols-3"
            v-if="!loading"
        >
            <card-basic
                v-for="module in modules"
                :key="module.name"
            >
                <div class="flex items-center justify-between -mb-3">
                    <div class="mb-3">
                        <h2 class="text-base">{{ moduleLabels[module.name] ? moduleLabels[module.name] : module.name }}</h2>
<!--                        <span-->
<!--                            class="inline-flex items-center px-2 py-1 mt-1 text-xs font-medium rounded-full"-->
<!--                            :class="{-->
<!--                                'bg-blue-100 text-blue-800': module.category === 'Website',-->
<!--                                'bg-green-100 text-green-800': module.category === 'Product',-->
<!--                                'bg-purple-100 text-purple-800': module.category === 'Email',-->
<!--                                'bg-orange-100 text-orange-800': module.category === 'Toolbox'-->
<!--                            }"-->
<!--                        >-->
<!--                            {{ module.category }}-->
<!--                        </span>-->
                    </div>
                    <div>
                        <toggle-switch
                            label=""
                            v-model:content="module.enabled"
                        />
                    </div>
                </div>
            </card-basic>
        </div>

        <div v-else>
            <div class="flex items-center justify-center h-full">
                <mf-spinner-medium
                    class="w-24 h-12"
                />
            </div>
        </div>

    </div>
</template>

<style scoped>

</style>
